import React, { useEffect, useState } from "react";

interface BirthdatePickerProps {
  onChange: (date: Date) => void;
  error?: string;
}

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const daysInMonth = (month: number, year: number) => {
  return new Date(year, month + 1, 0).getDate();
};

const BirthdatePicker: React.FC<BirthdatePickerProps> = ({ onChange, error }) => {
  const today = new Date();
  const [month, setMonth] = useState(today.getMonth());
  const [day, setDay] = useState(today.getDate());
  const [year, setYear] = useState(today.getFullYear());

  const years = Array.from({ length: 100 }, (_, i) => today.getFullYear() - i);

  useEffect(() => {
    onChange(new Date(year, month, day));
  }, [month, day, year]);

  const renderOptions = (count: number) =>
    Array.from({ length: count }, (_, i) => (
      <option key={i + 1} value={i + 1}>
        {i + 1}
      </option>
    ));

  return (
    <div className="flex flex-col w-full space-y-2 px-[30px] mb-[30px]">
      <label className="font-semibold text-black">Birthdate</label>
      <div className="flex flex-col w-full gap-[15px] md:flex-row md:gap-[15px] ">
        <div className="flex gap-[15px]">
          {/* Month */}
          <div className="relative w-[95px]">
            <select
              value={month}
              onChange={e => setMonth(parseInt(e.target.value))}
              className="w-full px-4 py-2 pr-8 text-black bg-white border border-gray-300 appearance-none rounded-xl"
            >
              {months.map((m, i) => (
                <option key={i} value={i}>
                  {m}
                </option>
              ))}
            </select>
            <div className="absolute inset-y-0 flex items-center pointer-events-none right-2">
              <svg className="w-4 h-4 text-black" viewBox="0 0 20 20" fill="currentColor">
                <path d="M5.5 7.5l4.5 4.5 4.5-4.5" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
              </svg>
            </div>
          </div>

          {/* Day */}
          <div className="relative w-[95px]">
            <select
              value={day}
              onChange={e => setDay(parseInt(e.target.value))}
              className="w-full px-4 py-2 pr-8 text-black bg-white border border-gray-300 appearance-none rounded-xl"
            >
              {renderOptions(daysInMonth(month, year))}
            </select>
            <div className="absolute inset-y-0 flex items-center pointer-events-none right-2">
              <svg className="w-4 h-4 text-black" viewBox="0 0 20 20" fill="currentColor">
                <path d="M5.5 7.5l4.5 4.5 4.5-4.5" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
              </svg>
            </div>
          </div>
        </div>
        {/* Year */}
        <div className="relative w-[95px]">
          <select
            value={year}
            onChange={e => setYear(parseInt(e.target.value))}
            className="w-full px-4 py-2 pr-8 text-black bg-white border border-gray-300 appearance-none rounded-xl"
          >
            {years.map(y => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          <div className="absolute inset-y-0 flex items-center pointer-events-none right-2">
            <svg className="w-4 h-4 text-black" viewBox="0 0 20 20" fill="currentColor">
              <path d="M5.5 7.5l4.5 4.5 4.5-4.5" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
            </svg>
          </div>
        </div>
      </div>
      {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
      {!error && <span className="block mb-2 text-sm text-gray-400 dark:text-gray-600">Your date of birth as shown on a government issued ID.</span>}
    </div>
  );
};

export default BirthdatePicker;
